import styled from 'styled-components';

export default styled.div`
  background: #161c34;
  height: 322px;
  border-radius: 14px;
`;
